import AddIcon from './AddIcon'
import AddLocationOutlinedIcon from './AddLocationOutlinedIcon'
import AllInclusiveIcon from './AllInclusiveIcon'
import AnalyticsGrowthIcon from './AnalyticsGrowthIcon'
import ApprovalDelegationIcon from './ApprovalDelegationIcon'
import Arrow360Icon from './Arrow360Icon'
import ArrowDownFilledIcon from './ArrowDownFilledIcon'
import ArrowDownIcon from './ArrowDownIcon'
import ArrowLeftIcon from './ArrowLeftIcon'
import ArrowRightIcon from './ArrowRightIcon'
import ArrowUpIcon from './ArrowUpIcon'
import BedroomIcon from './BedroomIcon'
import BoltIcon from './BoltIcon'
import BoltOutlinedIcon from './BoltOutlinedIcon'
import BookIcon from './BookIcon'
import BookSparklesIcon from './BookSparklesIcon'
import BreakfastIcon from './BreakfastIcon'
import BreakIcon from './BreakIcon'
import CalendarDisabledIcon from './CalendarDisabledIcon'
import CalendarEmptyIcon from './CalendarEmptyIcon'
import CalendarEnabledIcon from './CalendarEnabledIcon'
import CalendarIcon from './CalendarIcon'
import CalendarPlusIcon from './CalendarPlusIcon'
import CelebrationFilledIcon from './CelebrationFilledIcon'
import CelebrationIcon from './CelebrationIcon'
import ChallengeSportIcon from './ChallengeSportIcon'
import ChatIcon from './ChatIcon'
import ChatIconOutline from './ChatIconOutline'
import CheckCircleOutlineIcon from './CheckCircleOutlineIcon'
import CheckMarkIcon from './CheckMarkIconV2'
import CleaningIcon from './CleaningIcon'
import ClockIcon from './ClockIcon'
import CoachingTrainingIcon from './CoachingTrainingIcon'
import CocktailPartyIcon from './CocktailPartyIcon'
import CoffeeIcon from './CoffeeIcon'
import CollapsibleMenuBurgerIcon from './CollapsibleMenuBurgerIcon'
import Console from './Console'
import ContractDeleteIcon from './ContractDeleteIcon'
import CopyIcon from './CopyIcon'
import CopyMailIcon from './CopyMailIcon'
import CrossFilledIcon from './CrossFilledIcon'
import CrossIcon from './CrossIcon'
import CrossIconWithoutCircle from './CrossIconWithoutCircle'
import DeleteIcon from './DeleteIcon'
import DesignToolsIcon from './DesignToolsIcon'
import DesktopMacIcon from './DesktopMacIcon'
import DinnerIcon from './DinnerIcon'
import DomainDisabledIcon from './DomainDisabledIcon'
import DotIcon from './DotIcon'
import DotsIcon from './DotsIcon'
import DownloadIcon from './DownloadIcon'
import DownloadIcon2 from './DownloadIcon2'
import DragDropDotsIcon from './DragDropDotsIcon'
import EarlyCheckInIcon from './EarlyCheckInIconV2'
import EditIcon from './EditIcon'
import EmailFilledIcon from './EmailFilledIcon'
import EnvelopIcon from './EnvelopIcon'
import EuroIcon from './EuroIcon'
import EventProjectManagerIcon from './EventProjectManagerIcon'
import FilterIcon from './FilterIcon'
import BelgiumFlag from './flags/BelgiumFlag'
import EnglishFlag from './flags/EnglishFlag'
import FrenchFlag from './flags/FrenchFlag'
import GermanyFlag from './flags/GermanyFlag'
import ItalyFlag from './flags/ItalyFlag'
import NetherlandFlag from './flags/NetherlandFlag'
import SpainFlag from './flags/SpainFlag'
import FoodBankIcon from './FoodBankIcon'
import FormIcon from './FormIcon'
import FourSquaredGridIcon from './FourSquaredGridIcon'
import GameDiscoveryIcon from './GameDiscoveryIcon'
import GiftIcon from './GiftIcon'
import HappyTeamIcon from './HappyTeamIcon'
import HomeFilledIcon from './HomeFilledIcon'
import HomeOutlineIcon from './HomeOutlineIcon'
import InfoFilledIcon from './InfoFilledIcon'
import InfoOutlineIcon from './InfoOutlineIcon'
import KeyIcon from './KeyIcon'
import LateCheckoutIcon from './LateCheckoutIcon'
import LaundryIcon from './LaundryIcon'
import LeafIcon from './LeafIcon'
import ListIcon from './ListIcon'
import LockIcon from './LockIcon'
import LunchIcon from './LunchIcon'
import MapIcon from './MapIcon'
import MapPointerIcon from './MapPointerIcon'
import MenuBurgerIcon from './MenuBurgerIcon'
import MicIcon from './MicIcon'
import MiniBusIcon from './MiniBusIcon'
import MoodFilledIcon from './MoodFilledIcon'
import MoonFilledIcon from './MoonFilledIcon'
import MoonIcon from './MoonIcon'
import NewProfileIcon from './NewProfileIcon'
import NotesIcon from './Notes'
import OldPhone from './OldPhone'
import PaintBrushIcon from './PaintBrushIcon'
import Paper from './Paper'
import Paperclip from './Paperclip'
import PaperPlaneIcon from './PaperPlaneIcon'
import PaperValidated from './PaperValidated'
import PaperWarning from './PaperWarning'
import PencilIcon from './PencilIcon'
import PencilOutlineIcon from './PencilOutlineIcon'
import People from './People'
import PeopleOutline from './PeopleOutline'
import PersonPlayIcon from './PersonPlayIcon'
import PhoneIcon from './PhoneIcon'
import PictureIcon from './PictureIcon'
import PlusIcon from './PlusIcon'
import PrintDoc from './PrintDoc'
import ProfileIcon from './ProfileIcon'
import QuestionMarkIcon from './QuestionMarkIcon'
import RadioCheckedIcon from './RadioCheckedIcon'
import RadioUncheckedIcon from './RadioUncheckedIcon'
import RecordVideoIcon from './RecordVideoIcon'
import RedoIcon from './RedoIcon'
import RenewIcon from './RenewIcon'
import ResetIcon from './ResetIcon'
import RestaurantIcon from './RestaurantIcon'
import RiddleStrategyIcon from './RiddleStrategyIcon'
import RingingBell from './RingingBell'
import SearchIcon from './SearchIcon'
import SearchSmall from './SearchSmall'
import SendIcon from './SendIcon'
import SettingsIcon from './SettingsIcon'
import ShareIcon from './ShareIcon'
import ShellPermission from './ShellPermission'
import SmileyFaceIcon from './SmileyFaceIcon'
import SortIcon from './SortIcon'
import StarIcon from './StarIcon'
import SunFilledIcon from './SunFilledIcon'
import SunIcon from './SunIcon'
import SupportAgentIcon from './SupportAgentIcon'
import TeamsIcon from './TeamsIcon'
import ThreeDotsIcon from './ThreeDotsIcon'
import ThumbDownIcon from './ThumbDownIcon'
import ThumbDownOutlineIcon from './ThumbDownOutlineIcon'
import ThumbUpIcon from './ThumbUpIcon'
import ThumbUpOutlineIcon from './ThumbUpOutlineIcon'
import TrainIcon from './TrainIcon'
import TranslateIcon from './TranslateIcon'
import UploadIcon from './UploadIcon'
import UploadThin from './UploadThin'
import UserOutlineIcon from './UserOutlineIcon'
import VisibilityIcon from './VisibilityIcon'
import VisibilityOffIcon from './VisibilityOffIcon'
import WineIcon from './WineIcon'
import WorkspaceIcon from './WorkspaceIcon'

// TODO: Is this tree-shakeable?
const ICONS = {
  add: AddIcon,
  'add-location-outlined': AddLocationOutlinedIcon,
  'menu-burger': MenuBurgerIcon,
  'all-inclusive': AllInclusiveIcon,
  'analytics-growth': AnalyticsGrowthIcon,
  'approval-delegation': ApprovalDelegationIcon,
  'arrow-360': Arrow360Icon,
  'arrow-down': ArrowDownIcon,
  'arrow-down-filled': ArrowDownFilledIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  translate: TranslateIcon,
  bedroom: BedroomIcon,
  'belgium-flag': BelgiumFlag,
  bolt: BoltIcon,
  'bolt-outlined': BoltOutlinedIcon,
  book: BookIcon,
  'book-sparkles': BookSparklesIcon,
  break: BreakIcon,
  breakfast: BreakfastIcon,
  copy: CopyIcon,
  calendar: CalendarIcon,
  'calendar-plus': CalendarPlusIcon,
  'calendar-disabled': CalendarDisabledIcon,
  'calendar-enabled': CalendarEnabledIcon,
  'four-squared-grid': FourSquaredGridIcon,
  'smiley-face': SmileyFaceIcon,
  'calendar-empty': CalendarEmptyIcon,
  celebration: CelebrationIcon,
  'celebration-filled': CelebrationFilledIcon,
  'challenge-sport': ChallengeSportIcon,
  chat: ChatIcon,
  chatOutline: ChatIconOutline,
  'check-circle-outline': CheckCircleOutlineIcon,
  'collapsible-menu-burger': CollapsibleMenuBurgerIcon,
  'check-mark': CheckMarkIcon,
  'drag-drop-dots': DragDropDotsIcon,
  'three-dots': ThreeDotsIcon,
  'empty-check-mark': CheckMarkIcon,
  cleaning: CleaningIcon,
  clock: ClockIcon,
  ringingBell: RingingBell,
  'print-doc': PrintDoc,
  'coaching-training': CoachingTrainingIcon,
  'cocktail-party': CocktailPartyIcon,
  coffee: CoffeeIcon,
  'contract-delete': ContractDeleteIcon,
  delete: DeleteIcon,
  'copy-mail': CopyMailIcon,
  'cross-filled': CrossFilledIcon,
  cross: CrossIcon,
  'cross-without-circle': CrossIconWithoutCircle,
  'desktop-mac': DesktopMacIcon,
  'design-tools': DesignToolsIcon,
  dinner: DinnerIcon,
  'domain-disabled': DomainDisabledIcon,
  picture: PictureIcon,
  'person-play': PersonPlayIcon,
  dot: DotIcon,
  dots: DotsIcon,
  download: DownloadIcon,
  download2: DownloadIcon2,
  'early-check-in': EarlyCheckInIcon,
  edit: EditIcon,
  'email-filled': EmailFilledIcon,
  envelope: EnvelopIcon,
  'uk-flag': EnglishFlag,
  euro: EuroIcon,
  'event-project-manager': EventProjectManagerIcon,
  filter: FilterIcon,
  'french-flag': FrenchFlag,
  'food-bank': FoodBankIcon,
  form: FormIcon,
  'game-discovery': GameDiscoveryIcon,
  'germany-flag': GermanyFlag,
  gift: GiftIcon,
  'happy-team': HappyTeamIcon,
  'home-filled': HomeFilledIcon,
  'home-outline': HomeOutlineIcon,
  'italy-flag': ItalyFlag,
  'info-filled': InfoFilledIcon,
  'info-outline': InfoOutlineIcon,
  key: KeyIcon,
  'late-checkout': LateCheckoutIcon,
  laundry: LaundryIcon,
  leaf: LeafIcon,
  list: ListIcon,
  lock: LockIcon,
  lunch: LunchIcon,
  map: MapIcon,
  'map-pointer': MapPointerIcon,
  mic: MicIcon,
  'mini-bus': MiniBusIcon,
  'mood-filled': MoodFilledIcon,
  moon: MoonIcon,
  'moon-filled': MoonFilledIcon,
  'netherland-flag': NetherlandFlag,
  notes: NotesIcon,
  'old-phone': OldPhone,
  'paint-brush': PaintBrushIcon,
  'paper-plane': PaperPlaneIcon,
  paperclip: Paperclip,
  paper: Paper,
  'paper-validated': PaperValidated,
  'paper-warning': PaperWarning,
  pencil: PencilIcon,
  'pencil-outline': PencilOutlineIcon,
  people: People,
  'people-outline': PeopleOutline,
  plus: PlusIcon,
  phone: PhoneIcon,
  'user-filled': ProfileIcon,
  'user-circled-outline': NewProfileIcon,
  'question-mark': QuestionMarkIcon,
  'radio-checked': RadioCheckedIcon,
  'radio-unchecked': RadioUncheckedIcon,
  'record-video': RecordVideoIcon,
  redo: RedoIcon,
  renew: RenewIcon,
  reset: ResetIcon,
  restaurant: RestaurantIcon,
  'riddle-strategy': RiddleStrategyIcon,
  'user-outline': UserOutlineIcon,
  send: SendIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  share: ShareIcon,
  shellPermission: ShellPermission,
  sort: SortIcon,
  'spain-flag': SpainFlag,
  star: StarIcon,
  sun: SunIcon,
  upload: UploadIcon,
  'sun-filled': SunFilledIcon,
  'support-agent': SupportAgentIcon,
  teams: TeamsIcon,
  'thumb-down': ThumbDownIcon,
  'thumb-down-outline': ThumbDownOutlineIcon,
  'thumb-up': ThumbUpIcon,
  'thumb-up-outline': ThumbUpOutlineIcon,
  train: TrainIcon,
  visibility: VisibilityIcon,
  'visibility-off': VisibilityOffIcon,
  wine: WineIcon,
  workspace: WorkspaceIcon,
  console: Console,

  /**
   * @deprecated pass size in props instead of creating a "thin" or "small" icon
   * @example <Icon name="upload" className="size-5" /> // using tailwind
   * @example <Icon name="upload" size={20} /> // using props
   */
  uploadThin: UploadThin,
  'search-small': SearchSmall,
}

export default ICONS
